
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  // 富春山
  handleOpenShow() {
    window.open('https://mp.weixin.qq.com/s/lWKa90Wupz4pnJURpj7y1g')
  }

  handleOpenContent() {
    window.open('https://mp.weixin.qq.com/s/Pt467dhoY9JJxriiWobUrA')
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
